



















































































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { DataPoint, Gender, HSL, Name, NameData } from "../models";
import { paletteGenerator } from "../utils/paletteGenerator";
import {
  mdiDiceMultiple,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiAccountCircle,
  mdiGenderMaleFemale,
  mdiGenderFemale,
  mdiGenderMale,
  mdiShareCircle,
  mdiShareAll
} from "@mdi/js";
import GenderIcon from "../components/GenderIcon.vue";
import Matches from "../components/Matches.vue";
import NameDeck from "../components/NameDeck.vue";
import Ratings from "../components/Ratings.vue";
import VueSwing from "vue-swing/VueSwing.vue";
import { RouteConfig } from "vue-router";

@Component({
  components: {
    GenderIcon,
    Matches,
    NameDeck,
    Ratings,
    VueSwing
  },
  mounted() {
    const { id, gender, mode, otherID } = this.$route.params;

    const kindlingID = id || localStorage.getItem("baby-names-kindling-id");

    if (kindlingID === null) {
      fetch(`${process.env.VUE_APP_API_ROOT}/kindling/id/`)
        .then(res => res.json())
        .then(res => {
          const [id, mongoResponse] = res;
          localStorage.setItem("baby-names-kindling-id", id);
          this.$data.kindlingID = id;
          this.getKindling(id);
        });
    } else {
      this.$data.kindlingID = kindlingID;
    }
  }
})
export default class Kindling extends Vue {
  @Inject("secondaryColour") private secondaryColour!: HSL;

  get secondaryHSL() {
    const { hue, saturation, light } = this.secondaryColour;
    return `hsl(${hue},${saturation}%, ${Math.min(light + 20, 100)}%)`;
  }
  diceIcon = mdiDiceMultiple;
  queueBuffer = 5;

  loading = false;

  kindlingID: string | undefined = "";
  userName: string | undefined = "";
  isValidUser = false;
  isValidIcon = { true: mdiCheckCircleOutline, false: mdiCloseCircleOutline };
  userIcon = mdiAccountCircle;

  mdiGenderMaleFemale = mdiGenderMaleFemale;
  mdiGenderFemale = mdiGenderFemale;
  mdiGenderMale = mdiGenderMale;
  mdiShare =
    "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z";

  genderTabs = 1;
  get gender(): Gender | null {
    return ["girl" as Gender, null, "boy" as Gender][this.genderTabs];
  }

  unrated: Name[] = [];
  nameData: NameData[] = [];

  showShareDialog = false;

  accepted: Name[] = [];
  rejected: Name[] = [];
  get currentName(): NameData | null {
    return this.nameData[0] || null;
  }
  get matchesURL() {
    const BASE_URL = "http://localhost:8080/baby-names";
    return `${BASE_URL}/kindling/matches/${this.kindlingID}`;
  }
  get kindlingURL() {
    const BASE_URL = "http://localhost:8080/baby-names";
    return `${BASE_URL}/kindling/${this.kindlingID}`;
  }

  get routeTab() {
    const { otherID } = this.$route.params;
    let { mode } = this.$route.params;
    if (otherID) mode = "matches";
    switch (mode) {
      case "matches":
        return 2;
      case "ratings":
        return 1;
      case "rate":
      default:
        return 0;
    }
  }

  activeTab = this.routeTab;

  get urlParams() {
    return {
      id: this.kindlingID,
      user: this.userName
    };
  }

  setURL() {
    const id = this.kindlingID;
    const user = this.userName;
    const gender = this.gender;
    const { otherID } = this.$route.params;
    const mode =
      this.activeTab === 0
        ? "rate"
        : this.activeTab === 1
        ? "ratings"
        : "matches";

    if (!id) return;
    const params: { [key: string]: any } = { id, mode };
    let name = "Name Kindling id";

    if (otherID) {
      name += "-matches";
      params.otherID = otherID;
    }

    if (user) {
      name += "-user";
      params.user = user;
      if (gender) {
        name += "-gender";
        params.gender = gender;
      }
      if (mode) {
        name += "-mode";
        params.mode = mode;
      }
    }

    this.$router.replace({
      name,
      params
    });
  }

  createID() {
    fetch(`${process.env.VUE_APP_API_ROOT}/kindling/id/`)
      .then(res => res.text())
      .then(results => {
        const [id, mongoResponse] = results;
        this.kindlingID = id;
        this.getKindling(id, null);
      });
  }

  removeAllAccepted() {
    fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${this.kindlingID}/accept`,
      {
        method: "DELETE"
      }
    ).then(res => {
      if (res.status === 200) {
        this.accepted = [];
      }
    });
  }

  removeAllRejected() {
    fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${this.kindlingID}/reject`,
      {
        method: "DELETE"
      }
    ).then(res => {
      if (res.status === 200) {
        this.rejected = [];
      }
    });
  }

  removeFromAccepted(name: Name) {
    this.accepted = this.accepted.filter(
      n => n.name !== name.name || n.gender !== name.gender
    );
    fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${this.kindlingID}/accept/${
        name.name
      }/${name.gender || ""}`,
      {
        method: "DELETE"
      }
    ).then(res => {
      if (res.status !== 200) {
        this.accepted.push(name);
      } else {
        this.unrated.unshift(name);
        this.getMoreQueueData();
      }
    });
  }
  removeFromRejected(name: Name) {
    this.rejected = this.rejected.filter(
      n => n.name !== name.name || n.gender !== name.gender
    );

    fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${this.kindlingID}/reject/${
        name.name
      }/${name.gender || ""}`,
      {
        method: "DELETE"
      }
    ).then(res => {
      if (res.status !== 200) {
        this.rejected.push(name);
      } else {
        // succesfully unrated so add to start of queue
        this.unrated.unshift(name);
        this.getMoreQueueData();
      }
    });
  }

  accept() {
    const acceptedName = this.nameData.shift();
    const { name, gender } = acceptedName;
    fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${
        this.kindlingID
      }/accept/${name}/${gender || ""}`,
      {
        method: "PUT"
      }
    ).then(res => {
      if (res.status === 200) {
        this.accepted.push({ name, gender });
        this.getMoreQueueData();
      }
    });
  }

  reject() {
    const removedName = this.nameData.shift();
    const { name, gender } = removedName;
    fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${
        this.kindlingID
      }/reject/${name}/${gender || ""}`,
      {
        method: "PUT"
      }
    ).then(res => {
      if (res.status === 200) {
        this.rejected.push({ name, gender });
        this.getMoreQueueData();
      }
    });
  }

  async getMoreQueueData(n?: number) {
    const nameData = [...this.nameData];
    const namesToProcess = this.unrated.splice(0, n || 1);
    const namePromises = namesToProcess.map(async n => this.getNameData(n));

    const newNameData = await Promise.all(namePromises);

    this.nameData.push(...newNameData);
  }

  @Watch("isValidUser")
  async onValidUserChange(val: boolean) {
    if (val) this.setURL();
  }

  @Watch("activeTab")
  async onActiveTabChange(val: boolean) {
    this.setURL();
  }

  @Watch("kindlingID")
  async onKindlingIdChange(val: boolean) {
    this.setURL();
    this.getKindling(this.kindlingID, this.gender);
  }

  async getNameData(inputName: Name): Promise<NameData> {
    const { name, gender, meaning, origin } = inputName;
    const nameReq = await fetch(
      `${process.env.VUE_APP_API_ROOT}/births/${name}/gender/${gender}`
    );
    const meaningResponse = await fetch(
      `${process.env.VUE_APP_API_ROOT}/names/${name}/gender/${gender}/meaning`
    );
    const nameJson = await nameReq.json();

    const meaningJson = (await meaningResponse.json()) as {
      meaning: string | null;
      origin: string | null;
    };
    return {
      ...inputName,
      ...meaningJson,
      data: nameJson
    };
  }

  async getKindling(kindlingID: string, gender: Gender | null) {
    this.loading = true;
    const kindlingReq = await fetch(
      `${process.env.VUE_APP_API_ROOT}/kindling/id/${kindlingID}${
        gender ? "/gender/" + gender : ""
      }`
    );
    const json = await kindlingReq.json();
    const data = json.data;

    this.isValidUser = Boolean(data);
    if (!data) return;
    const { unrated, accepted, rejected } = data;
    this.loading = false;
    this.unrated = unrated;

    this.accepted = accepted;
    this.rejected = rejected;

    this.nameData = [];
    this.getMoreQueueData(this.queueBuffer);
  }

  @Watch("gender")
  async onGenderChange(val: Gender | null) {
    this.getKindling(this.kindlingID, val);
    this.setURL();
  }

  @Watch("userName")
  async onUserNameChange(val: string) {
    this.getKindling(this.kindlingID, this.gender);
  }
}
